import React, { useEffect, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { useTranslation } from 'react-i18next'
import { Alert } from 'reactstrap'
import { Stack } from '@mantine/core'
import { Text } from '@mantine/core'
import { bookingsAPI } from '@/features/bookings/api'
import { useBookingData } from '@/features/bookings/hooks'
import { BookingReportModel } from '@/features/bookings/types/models'
import { Loading } from '@/features/chat/components/Chat/Chat/Room/MessagesContainer/MessagesList/Loading'
import { convertListNamesToNames } from '@/helpers/common/utils'
import { FormTypes } from '@/types'

export const BookingBabysitterResumeContainer = () => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState<boolean | null>(true)
  const [reports, setReports] = useState<string[]>([])
  const [alertError, setAlertError] = useState<FormTypes.ValidationErrors | null>(null)

  const { booking } = useBookingData()
  useEffect(() => {
    loadReportData()
  }, [])

  const loadReportData = async () => {
    try {
      const { data } = await bookingsAPI.getBookingReports(booking?.id || 0)
      const translatedReports = [] as string[]
      data.data.map((item: BookingReportModel) => {
        const translated = t('report.content.client')
          .replace('#babysitter#', item.babysitter)
          .replace('#children#', convertListNamesToNames(item?.children_names || []))
          .replace('#date#', item.date)
          .replace('#activities#', item.activities)
          .replace('#interactions#', item.interactions)
          .replace('#routine#', item.routine)
          .replace('#suggestions#', item.suggestions)
          .replace(/\n/g, '<br />')

        translatedReports.push(translated)
      })
      setReports(translatedReports)
      setLoading(false)
    } catch (err) {
      const serverError = err as FormTypes.ValidationErrors
      setAlertError(serverError)
      setLoading(false)
    }
  }

  return (
    <div>
      {loading ? (
        <div className="mt-4">
          <Loading />
        </div>
      ) : (
        <Stack className="gap-2">
          <>
            {alertError && (
              <Alert type={'error'} mb={'sm'} mt={'sm'}>
                {alertError?.message || t('error')}
              </Alert>
            )}
            {!alertError &&
              reports.map((report: string) => (
                <Text className="m-2">{ReactHtmlParser(report)}</Text>
              ))}
            {!alertError && reports.length == 0 && (
              <div className={'w-100 d-flex justify-center mt-2'}>
                <Text>{t('reports.nodata')}</Text>
              </div>
            )}
          </>
        </Stack>
      )}
    </div>
  )
}
